module.exports = __webpack_public_path__ + "img/disocunt_back@2x.80cbf092.png";